import { Parser } from "@siteimprove/alfa-parser";
import { Token } from "../../../../syntax/index.js";
import { Value } from "../../../value.js";
import { Position } from "./position.js";
const { map, option, right } = Parser;
/**
 * @internal
 */
export class Side extends Value {
    static of(side) {
        return new Side(side);
    }
    _side;
    constructor(side) {
        super("side", false);
        this._side = side;
    }
    get side() {
        return this._side;
    }
    resolve() {
        return this;
    }
    equals(value) {
        return value instanceof Side && value._side === this._side;
    }
    hash(hash) {
        hash.writeString(this._side);
    }
    toJSON() {
        return { ...super.toJSON(), side: this._side };
    }
    toString() {
        return `to ${this._side}`;
    }
}
/**
 * @internal
 */
(function (Side) {
    /**
     * {@link https://drafts.csswg.org/css-images/#typedef-side-or-corner}
     *
     * @internal
     */
    Side.parse = map(right(Token.parseIdent("to"), right(option(Token.parseWhitespace), Position.parse)), (side) => Side.of(side));
})(Side || (Side = {}));
//# sourceMappingURL=side.js.map